<template>
  <nav class="hidden space-x-1 md:block">
    <template v-for="item of navigationItems">
      <UiButton
        v-if="item.openMenu"
        :id="`navigation-${item.key}`"
        :key="`${item.key}-button`"
        variant="navigation"
        :aria-haspopup="true"
        :aria-expanded="isOpen"
        :icon="IconChevron"
        icon-side="right"
        :loading="!item.label"
        @click="toggle(item.key as MenuContext)"
      >
        {{ item.label }}
      </UiButton>
      <UiLink
        v-else
        :id="`navigation-${item.key}`"
        :key="`${item.key}-link`"
        variant="navigation"
        :underline="false"
        :to="item.url"
      >
        {{ item.label }}
      </UiLink>
    </template>
  </nav>
</template>

<script setup lang="ts">
import { IconChevron } from '#components';

import type { HeaderNavigationProps, MenuContext, NavigationItem } from '~/components/Header/types';

import menuData from '~/assets/data/menu.json';
import { useCmsStore } from '~/stores/cms/cmsStore';

const { locale, t } = useI18n();

const cmsStore = useCmsStore();

const { menu } = storeToRefs(cmsStore);

const navigationItems = ref<NavigationItem[]>();

watch(
  [locale, menu],
  () => {
    navigationItems.value = menuData.map((item: NavigationItem) => ({
      ...item,
      label: item.label ? t(item.label) : (cmsStore.menu?.title ?? null),
    }));
  },
  { immediate: true },
);

defineProps<HeaderNavigationProps>();
</script>
